export default __webpack_public_path__ + "static/media/georgetown.435e79a7.png";